import React from 'react'

const Progressbar = ({isVisible, Actualyquestion, maxQuestion}) => {
    if(!isVisible) return <></>;
    const progress = Math.floor((Actualyquestion/maxQuestion)*100)
    return (
        <div className="progress-container">
            <div className="progress"
                 style={{ width: `${progress}%` }}
                 role="progressbar"
                 aria-valuenow={progress}
                 aria-valuemin="0"
                 aria-valuemax="100">
                <span className="progress-value">{progress}%</span>
            </div>
        </div>
    )
};
export default Progressbar;